const actions = {
    TEST_MPS_LOGIN_REQUEST: 'TEST_MPS_LOGIN_REQUEST',
    TEST_MPS_LOGIN_SUCCESS: 'TEST_MPS_LOGIN_SUCCESS',
    TEST_MPS_LOGIN_ERROR: 'TEST_MPS_LOGIN_ERROR',
    TEST_MPS_SYNC_REQUEST: 'TEST_MPS_SYNC_REQUEST',
    TEST_MPS_SYNC_SUCCESS: 'TEST_MPS_SYNC_SUCCESS',
    TEST_MPS_SYNC_ERROR: 'TEST_MPS_SYNC_ERROR',
    TEST_RESET_STATE: 'TEST_RESET_STATE',

    TEST_FW_OPEN_MODAL: "TEST_FW_OPEN_MODAL",
    TEST_FW_CLOSE_MODAL: "TEST_FW_CLOSE_MODAL",

    mpsLogin: request => ({
        type: actions.TEST_MPS_LOGIN_REQUEST,
        request,
    }),
    mpsSync: request => ({
        type: actions.TEST_MPS_SYNC_REQUEST,
        request,
    }),

    openFloatingWindow: () => ({
        type: actions.TEST_FW_OPEN_MODAL,
    }),
    closeFloatingWindow: () => ({
        type: actions.TEST_FW_CLOSE_MODAL,
    }),

    resetState: () => ({
        type: actions.TEST_RESET_STATE,
    }),
};
export default actions;
